import { Base } from "../Base";
import { Name } from "../Name";
import { system } from "../system";
export class Class extends Base {
    base;
    class = "intersection";
    _name;
    get name() {
        return (this._name ??= Name.fromIntersection(this.base));
    }
    get definition() {
        return Object.assign(super.definition, { base: this.base.map(b => b.definition) });
    }
    constructor(base, name) {
        super();
        this.base = base;
        this._name = name;
    }
    is(value) {
        return this.base.every(b => b.is(value));
    }
    prune(value) {
        return !this.is(value)
            ? undefined
            : value && typeof value == "object"
                ? this.base.reduce((r, b) => merge(r, b.prune(value)), {})
                : value;
    }
    flawed(value) {
        const result = super.flawed(value);
        return (result && {
            ...result,
            flaws: this.base.map(t => t.flawed(value)).filter((v) => v != false),
        });
    }
    static create(...base) {
        return new Class(base);
    }
}
function merge(target, source) {
    return Array.isArray(target) && Array.isArray(source)
        ? target.map((item, index) => merge(item, source[index]))
        : target && typeof target == "object" && source && typeof source == "object"
            ? system.Object.fromEntries([
                ...system.Object.entries(target),
                ...system.Object.entries(source).map(([key, value]) => [
                    key,
                    system.Object.getOwnPropertyDescriptor(target, key) &&
                        typeof target[key] == "object" &&
                        typeof value == "object"
                        ? merge(target[key], value)
                        : value,
                ]),
            ])
            : target;
}
//# sourceMappingURL=Class.js.map